import { gql } from '@apollo/client';

export const ENTITY_CRITICALITY_LISTS_SELECT_QUERY = gql`
  query EntityCriticalitySelectConfigs {
    entityCriticalityConfigs {
      total
      objects {
        id
        name
        severityExpression
      }
    }
  }
`;
